module.exports = __webpack_public_path__ + "static/media/condorcet_graph_1.532cc771.png";